export const getCertificateInfoContainerStyles = ({ isTabletSM }) => ({
  background: 'rgba(255, 255, 255, 0.16)',
  flexDirection: isTabletSM ? 'column' : 'row',
  p: isTabletSM ? 16 : 24,
});

export const getCertificateContentContainerStyles = ({ isTabletSM }) => ({
  alignItems: isTabletSM ? 'flex-start' : 'center',
  flexDirection: isTabletSM ? 'column' : 'row',
  justifyContent: 'space-between',
  width: '100%',
});

export const getCertificateImageStyles = ({ isTabletSM }) => ({
  height: isTabletSM ? 'auto' : '146px',
  mr: isTabletSM ? 0 : 32,
  width: isTabletSM ? '100%' : '270px',
});

export const styles = {
  settingsIcon: {
    cursor: 'pointer',
    height: '40px',
    width: '40px',
  },
};
